// Utility to generate a stable widget id based on name.
// Pattern: slugified name (lowercase alphanum + hyphens) truncated, plus short random suffix if collision.
export function generateWidgetId(name, existingIds = []) {
  const set = new Set(existingIds);
  const base = (name || 'widget')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40) || 'widget';
  if (!set.has(base)) return base;
  // Try with numeric increment first to keep readability
  let i = 2;
  while (!set.has(`${base}-${i}`) === false && i < 50) i++;
  let candidate = `${base}-${i}`;
  if (set.has(candidate)) {
    // Fallback to random 4-char suffix
    let tries = 0;
    while (tries < 20) {
      const rand = Math.random().toString(36).slice(2, 6);
      candidate = `${base}-${rand}`;
      if (!set.has(candidate)) break;
      tries++;
    }
  }
  return candidate;
}

export function ensureWidgetId(widget, existingIds = []) {
  if (widget.id) return widget;
  return { ...widget, id: generateWidgetId(widget.widgetName || widget.widgetname || 'widget', existingIds) };
}